import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const vk: Platform = {
  id: 'vk',
  name: 'VK',
  iconIndex: PlatformRegistry.vk.index,
  color: PlatformRegistry.vk.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://vk.com/share.php', {
      url: content.url,
      image: content.image,
    });
  },
};

